export const MAX_ALLOW_CHARS = 1000;

export const MODAL_WIDTH = 452;

export const GENERATION_DISCARD_TEXT = 'AltTextModal';
